var _jsxFileName = "/home/runner/work/frontend-shared/frontend-shared/src/components/feedback/Spinner.tsx";
import classnames from 'classnames';
import { SpinnerSpokesIcon } from '../icons';
import { jsxDEV as _jsxDEV } from "preact/jsx-dev-runtime";
/**
 * Style a spinner icon.
 */
export default function Spinner({
  size = 'sm',
  color = 'text-light'
}) {
  return _jsxDEV(SpinnerSpokesIcon, {
    className: classnames({
      'text-color-text-light': color === 'text-light',
      // default
      'text-color-text': color === 'text',
      'text-color-text-inverted': color === 'text-inverted'
    }, {
      'w-em h-em': size === 'sm',
      // default
      'w-2em h-2em': size === 'md',
      'w-4em h-4em': size === 'lg'
    }),
    "data-component": "Spinner"
  }, void 0, false, {
    fileName: _jsxFileName,
    lineNumber: 18,
    columnNumber: 5
  }, this);
}
//# sourceMappingURL=Spinner.js.map